import React, { useContext } from "react";
import { TextField } from "@mui/material";
import GroupBDRBiologists from "../FieldTags/GroupBDRBiologists";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === '/xplans/new';

const RecipientInvestigator = ({ recipientInvestigator, handleChange, xplans, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.APPROVER]);

    return (
        <div id="recipientInvestigator" className="planField">
            <GroupBDRBiologists />
            <TextField
                name="otherName"
                label={xplanLabels.recipientInvestigator}
                InputLabelProps={{ shrink: true }}
                type="text"
                required={required.includes("recipientInvestigator")}
                value={recipientInvestigator ? recipientInvestigator  : ""}
                onChange={(e) => handleChange("recipientInvestigator", e.target.value)}
                className="fullLength"
                disabled={!canEdit}
            />
            {!newPlan && <HistoryLogElement xplans={xplans} label={"recipientInvestigator"} />}
        </div>
    );
};

export default RecipientInvestigator;